import asana from "@common/assets/images/integrations/asana-icon.svg";
import azure from "@common/assets/images/integrations/azure-icon.svg";
import clickup from "@common/assets/images/integrations/clickup-icon.svg";
import github from "@common/assets/images/integrations/github-icon.svg";
import jira from "@common/assets/images/integrations/jira-icon.svg";
import linear from "@common/assets/images/integrations/linear-icon.svg";
import notion from "@common/assets/images/integrations/notion-icon.svg";
import sentry from "@common/assets/images/integrations/sentry-icon.svg";
import slack from "@common/assets/images/integrations/slack-icon.svg";
import trello from "@common/assets/images/integrations/trello-icon.svg";
import webhook from "@common/assets/images/integrations/webhook-icon.svg";
import zapier from "@common/assets/images/integrations/zapier-icon.svg";
import { IntegrationType } from "@common/models/integrations";

export const getIntegrationTypeLogo = (integrationType: IntegrationType) => {
  switch (integrationType) {
    case IntegrationType.ASANA:
      return asana;
    case IntegrationType.AZURE_DEVOPS:
      return azure;
    case IntegrationType.CLICKUP:
      return clickup;
    case IntegrationType.GITHUB:
      return github;
    case IntegrationType.JIRA:
    case IntegrationType.JIRA_CLOUD:
    case IntegrationType.JIRA_SERVER:
      return jira;
    case IntegrationType.SLACK:
      return slack;
    case IntegrationType.TRELLO:
      return trello;
    case IntegrationType.LINEAR:
      return linear;
    case IntegrationType.ZAPIER:
      return zapier;
    case IntegrationType.SENTRY:
      return sentry;
    case IntegrationType.NOTION:
      return notion;
    default:
      return webhook;
  }
};
